import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const fetchFeatured = (page = 1) =>
  axios.get(`${API}asplapi/featured/?page=${page}`);

export const searchLive = (q) =>
  axios.get(`${API}asplapi/search/?q=${encodeURIComponent(q)}`);

export const autocompleteSearch = (q) =>
  axios.get(`${API}asplapi/index/search/?q=${encodeURIComponent(q)}`);

export const getProductById = (id) =>
  axios.get(`${API}asplapi/products/?ids=${id}`);
